import {
    ADD_AGENT_REQUEST,
    ADD_AGENT_SUCCESS,
    ADD_AGENT_FAILURE,
    DELETE_AGENT_REQUEST,
    DELETE_AGENT_SUCCESS,
    DELETE_AGENT_FAILURE
} from '../../actions';

interface Agent {
    id: number;
    user_id: string;
    raw_data: string[];
    location: string;
}

interface AgentState {
    loading: boolean;
    agents: Agent[];  // This should be an array to hold the list of agents
    error: string | null;
}

const initialState: AgentState = {
    loading: false,
    agents: [],
    error: null
};

const agentReducer = (state = initialState, action: any): AgentState => {
    switch (action.type) {
        case ADD_AGENT_REQUEST:
        case DELETE_AGENT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case ADD_AGENT_SUCCESS:
            return {
                ...state,
                loading: false,
                agents: [...state.agents, action.payload], // Add the new agent to the list
                error: null
            };
        case ADD_AGENT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case DELETE_AGENT_SUCCESS:
            return {
                ...state,
                loading: false,
                agents: state.agents.filter(agent => agent.id !== action.payload), 
                error: null
            };
        case DELETE_AGENT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        default:
            return state;
    }
};

export default agentReducer;
